import React from 'react';
import {Footer} from './footer';
import {Popup, Goals, UI, Collaboration} from 'components';
import {last, get, useNamedSelector, useDrop} from 'helpers';
import {goals} from 'store';
import {attach as attachToActivity} from 'store/activities';

const attach = (event, grabbed) => {
  (grabbed.type === 'milestone' ? goals.dispatch.attach : attachToActivity)(event, grabbed);
};

export function Card(props) {
  const details = useNamedSelector('goals.details', { id: props.id, context: 'goals' });
  const { Card } = UI;
  const { Checkbox, hasThumbnail, hasChart, onCalendar, Body = Card.Body, Status = Collaboration.CardStatus, ActionMenu = Popup.Menu.Handle } = props;
  const { goal, editable, images, timeframe, project, disabled } = details;
  const onDrop = useDrop(attach, ({type}) => type.match(/activity|milestone/));

  return (
    <Card {...props} status={goal.status} timeframe={timeframe} disabled={disabled} {...onDrop}>

      <Status selector="goals.details" id={props.id} />

      { hasThumbnail &&
        <Card.Thumbnail src={get(last(images), 'url')} background={goal.category} show-for-xxlarge />
      }

      { Checkbox &&
        <Checkbox {...goal} />
      }

      <ActionMenu id={props.id} editable={editable} disabled={disabled} Menu={Goals.Single.Menu} />

      <Body {...details} hasChart={hasChart}>
        <Card.Text is3LinesMax={!props.detailed}>{ goal.name }</Card.Text>
        <Card.Note is3LinesMax={!props.detailed}>{ goal.note }</Card.Note>
        { !hasChart && project && !props.withoutProject &&
          <Card.Note>{ project.name }</Card.Note>
        }
        { (props.detailed || hasChart) &&
          <Goals.Single.TrackStats {...props} {...goal} />
        }
        { hasChart &&
          <Goals.Single.Chart {...props} />
        }
      </Body>

      { !hasChart && !onCalendar &&
        <Footer goal={goal} {...props} />
      }

      { onDrop && !disabled &&
        <Card.Dropzone>Drop here to link to this goal</Card.Dropzone>
      }
    </Card>
  );
}
